'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Key2) {
  Key2[Key2["ESCAPE"] = 0] = "ESCAPE";
  Key2[Key2["ARROW_DOWN"] = 1] = "ARROW_DOWN";
  Key2[Key2["ARROW_UP"] = 2] = "ARROW_UP";
  Key2[Key2["ARROW_LEFT"] = 3] = "ARROW_LEFT";
  Key2[Key2["ARROW_RIGHT"] = 4] = "ARROW_RIGHT";
  Key2[Key2["TAB"] = 5] = "TAB";
  Key2[Key2["CONTROL"] = 6] = "CONTROL";
  Key2[Key2["SHIFT"] = 7] = "SHIFT";
  Key2[Key2["META"] = 8] = "META";
  Key2[Key2["DELETE"] = 9] = "DELETE";
  Key2[Key2["BACKSPACE"] = 10] = "BACKSPACE";
  Key2[Key2["UNIDENTIFIED"] = 11] = "UNIDENTIFIED";
})(exports.Key || (exports.Key = {}));
const SpecialKeys = {
  [0]: ["Esc", "Escape", 27],
  [1]: ["Down", "ArrowDown", 40],
  [2]: ["Up", "ArrowUp", 38],
  [3]: ["Left", "ArrowLeft", 37],
  [4]: ["Right", "ArrowRight", 39],
  [5]: ["Tab", 9],
  [6]: ["Control", 17],
  [7]: ["Shift", 16],
  [8]: ["Win", "Meta", 91],
  [10]: ["Backspace", 8],
  [9]: ["Delete", 46],
  [11]: ["Unidentified", 229]
};
const AllSpecialKeys = Object.values(SpecialKeys).reduce((curr, prev) => curr.concat(...prev), []);
const NumberKeys = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57
];
function isEscapeKey(event) {
  return SpecialKeys[0].includes(event.key || event.keyCode);
}
function isSpecialKey(event) {
  return AllSpecialKeys.includes(event.key || event.keyCode);
}
function isNumericKey(event) {
  return NumberKeys.includes(event.key || event.keyCode);
}

exports.isEscapeKey = isEscapeKey;
exports.isNumericKey = isNumericKey;
exports.isSpecialKey = isSpecialKey;
